var _rect, _rect2, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FFF5F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.5586,
    y: 9.69141,
    width: 18,
    height: 1,
    rx: 0.5,
    fill: "#D91F05"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.22522 17.428L10.946 10.587L14.4368 10.6778L14.0129 18.159C13.9284 19.6504 12.5322 20.7139 11.0719 20.3993C9.7267 20.1095 8.88953 18.7625 9.22522 17.428Z",
    stroke: "#D91F05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5253 18.5929L14.7274 10.6011L18.8375 10.6011L18.8375 18.6474C18.8375 19.8384 17.872 20.8038 16.681 20.8038C15.4687 20.8038 14.4947 19.8048 14.5253 18.5929Z",
    stroke: "#D91F05"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4427 18.3285L19.4427 10.6093L24.018 10.6836L24.018 18.3285C24.018 19.5919 22.9938 20.6162 21.7303 20.6162C20.4669 20.6162 19.4427 19.592 19.4427 18.3285Z",
    stroke: "#D91F05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.322 17.4704L28.1388 10.5866L24.0385 10.6797L24.4392 18.0214C24.5183 19.4717 25.8297 20.5383 27.2657 20.3205C28.6282 20.1138 29.5555 18.8286 29.322 17.4704Z",
    stroke: "#D91F05"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.1362 23.648C9.13204 23.6439 9.125 23.6468 9.125 23.6527V31.2637H29.5491V23.6534C29.5491 23.6471 29.5416 23.6438 29.537 23.648L29.4065 23.7669C28.0306 25.0203 25.9076 24.9534 24.6134 23.6157V23.6157C24.6108 23.6131 24.6066 23.6129 24.6038 23.6155V23.6155C23.1226 24.9753 20.831 24.9667 19.3419 23.6154V23.6154C19.3391 23.6128 19.3349 23.6127 19.332 23.6151L19.1239 23.7837C17.6013 25.0182 15.3669 24.7885 14.1273 23.27V23.27C14.1246 23.2666 14.1196 23.2665 14.1166 23.2696L13.8434 23.5603C12.5777 24.9071 10.4512 24.9467 9.1362 23.648V23.648Z",
    stroke: "#D91F05"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarket);
export default __webpack_public_path__ + "static/media/market.18f0da321c0aeabcc64c5ccdd413b5b0.svg";
export { ForwardRef as ReactComponent };